import { Component, OnInit, Input, NgModule, SimpleChanges } from '@angular/core';
import { formatDate, Location } from '@angular/common';
import { Comprobante } from 'src/app/shared/models/facturacion/Comprobante';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { HttpHeaders } from '@angular/common/http';
import { ComprobanteService } from 'src/app/facturacion/comprobante.service';
import { SharedService } from '../shared.service';
import { Rubro } from '../models/despacho/Rubro';
import { NgbDateStruct, NgbDropdownItem, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'src/app/shell/message.service';
import { VisorImpuestoComponent } from '../visor-impuesto/visor-impuesto.component';
import { ImpuestoPercepcion } from '../models/facturacion/ImpuestoPercepcion';
import { TipoMoneda } from '../enums/tipoMoneda';
import { UsuarioService } from 'src/app/account/usuario.service';
import { Aeroplanta } from '../models/despacho/Aeroplanta';
import { CondicionVentaFactura } from '../enums/condicionVentaFactura';
import { TipoDocumento } from '../enums/tipoDocumento';
import { NotificacionesService } from 'src/app/abm/notificacion/notificaciones.service';
import { NotificacionesComprobantes } from '../models/notificaciones/NotificacionesComprobantes';
import { ErrorModel } from '../models/ErrorModel';
import { EstadoFactura } from '../enums/EstadoFactura';
import { TipoMovimiento } from '../models/facturacion/TipoMovimiento';
import { Renglon } from '../models/facturacion/Renglon';

@Component({
  selector: 'app-visor-comprobante',
  templateUrl: './visor-comprobante.component.html',
  styleUrls: ['./visor-comprobante.component.css']
})
export class VisorComprobanteComponent implements OnInit {

  baseUrl = environment.apiServer.facturacionBaseUrl;
  private comprobanteUrl = this.baseUrl + '/ComprobantesV1';
  private exportarUrl = this.comprobanteUrl + '/Remitos/Exportar';

  cuit: string;
  columnas = [];
  mensajeSpinner: string;
  esDolar: boolean = false;
  monedaPalabra: string = '';
  rubros: Rubro[] = [];
  array: any[] = [];
  string: string = '';
  efectivo: number;
  elementType = 'url';
  email: any;
  @Input() facturaObtenida: Comprobante;
  @Input() botones: boolean = true;

  impresionTermica: boolean = true;
  mostrarMensajeFacturacionEnPruebas: boolean = false;
  descargando: boolean = false;
  reenviando: boolean = false;
  mensajeError: string;

  comprobanteNotificaciones: NotificacionesComprobantes = null;

  aeroplanta: Aeroplanta[] = [];
  EstadoFactura=EstadoFactura;

  constructor(
    private comprobanteService: ComprobanteService,
    private notificacionesService: NotificacionesService, 
    private messageService: MessageService,
    private location: Location, 
    public activeModal: NgbModal,
    private spinner: NgxSpinnerService, 
    private httpClient: HttpClient, 
    private sharedService: SharedService, 
    private usuarioService: UsuarioService) 
    { 
    }

  ngOnInit() {
    this.comprobanteNotificaciones = new NotificacionesComprobantes;
    this.mostrarMensajeFacturacionEnPruebas = this.usuarioService.getAeroplantaActual().habilitarFacturacion && (! this.usuarioService.getAeroplantaActual().soloPAD);
    
    setTimeout(() => {
    }, 3000);
    this.spinner.show('spinnerLista');
    switch (this.facturaObtenida.tipoMovimiento) {
      case (2):
      case (7): {
        this.columnas = [
          { field: 'Rubro', header: 'Rubro' },
          { field: 'Detalle', header: 'Descripción' },
          { field: 'Cantidad', header: 'Cant.' },
          { field: 'UMedida', header: 'UM' },
          { field: 'PUnitario', header: 'Valor Unitario' },
          { field: 'Total', header: 'Total' },
        ];
        this.getRubros();
        break;
      }
      default: {
        this.columnas = [
          { field: 'Codigo', header: 'Cod.' },
          { field: 'Detalle', header: 'Descripción' },
          { field: 'Cantidad', header: 'Cant.' },
          { field: 'UMedida', header: 'UM' },
          { field: 'PUnitario', header: 'Valor Unitario' },
          { field: 'Total', header: 'Total' },
        ];
      }
    }
    this.facturaObtenida.tipoMoneda == 0 ? this.monedaPalabra = 'PESOS' : this.monedaPalabra = 'DOLARES';
    this.mensajeSpinner = "Descargando..."
    this.renglones();
    this.calcularEfectivo();
    setTimeout(() => {
      this.spinner.hide('spinnerLista');
    }, 5000);
  }

  renglones() {
    this.string = '';
    for (let i = 0; this.facturaObtenida.factura.leyendas.length > i; i++) {
      if (this.facturaObtenida.factura.leyendas[i].frame == 0 && this.facturaObtenida.factura.leyendas[i].activo) {
        this.string = `${this.string}` + `${this.facturaObtenida.factura.leyendas[i].descripcion}` + '\n';
      }
    }
    this.string = this.string.slice(0, 884);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.facturaObtenida.firstChange) {
      this.ngOnInit();
    }

    this.efectivo = 0;
    this.calcularEfectivo();
  }


  calcularEfectivo() {
    this.efectivo = 0;
    this.efectivo = this.facturaObtenida.factura.total;
    if (this.facturaObtenida.factura.pago.length > 0) {
      for (let i = 0; this.facturaObtenida.factura.pago.length > i; i++) {
        for (let j = 0; this.facturaObtenida.factura.pago[i].cupones.length > j; j++) {
          this.efectivo = this.efectivo - this.facturaObtenida.factura.pago[i].cupones[j].importe;
        }
      }
    }
  }

  getRubros() {
    this.comprobanteService.getRubros()
      .subscribe(result => {
        (this.rubros = result);
        for (let i = 0; this.rubros.length > i; i++) {
          for (let j = 0; this.facturaObtenida.factura.renglones.length > j; j++) {
            if (this.rubros[i].id == this.facturaObtenida.renglones[j].rubro.id) {
              this.facturaObtenida.renglones[j].rubro.nombre = this.rubros[i].nombre;
            }
          }
        }
      });
  }

  formatearNroDocumento(tipoDoc: number, nroDoc: string) {
    if(tipoDoc == TipoDocumento.CUIL || tipoDoc == TipoDocumento.CUIT){
      if (nroDoc.includes("-")){
        return (nroDoc)
      }else{
        nroDoc = nroDoc.substr(0, 2) + - + nroDoc.substr(2, 8) + - + nroDoc.substr(10);
        return (nroDoc)
      }    
    }else{
      return nroDoc;
    }
  }

  leyendaTipoDocumento(tipoDoc: number){
    if(tipoDoc == TipoDocumento.CUIT){
      return "CUIT";
    }else if(tipoDoc == TipoDocumento.CUIL){
      return "CUIL";
    }else if(tipoDoc == TipoDocumento.DNI){
      return "DNI";
    }else if(tipoDoc == TipoDocumento.Extranjero){
      return "DOCUMENTO";
    }
  }

  obtenerTipoComprobante(tipoMovimiento: number) {
    switch (tipoMovimiento) {
      case (1):
      case (3):
      case (2): {
        return 'A'
      }
      case (6):
      case (8):
      case (7): {
        return 'B';
      }
      case (9): {
        return 'R';
      }
      case (19):
      case (20):
      case (21): {
        return 'E'
      }
    }
  }

  goBack() {
    this.location.back(); // <-- go back to previous location on cancel
  }

  obtenerCondicionVenta(condicion: number) {
    if (condicion === CondicionVentaFactura.contado) { 
      return "Contado"; 
    }else if(condicion === CondicionVentaFactura.cuentaCorriente){ 
      return "Cuenta Corriente"; 
    }else if(condicion === CondicionVentaFactura.previoPago){ 
      return "Previo Pago"; 
    }else{ 
      return "-"; 
    }
  }
  obtenerNombreComprobante(tipoMovimiento: number) {
    switch (tipoMovimiento) {
      case (1):
      case (6):
      case (19): {
        if (this.facturaObtenida.factura.condicionVenta == 1) {
          return 'FACTURA/RECIBO';
        } else {
          return 'FACTURA';
        }
      }
      case (2):
      case (7):
      case (20): {
        return 'NOTA DE DEBITO';
      }
      case (3):
      case (8):
      case (21): {
        return 'NOTA DE CREDITO';
      }
      case (9): {
        return 'REMITO';
      }
      case (99): {
        return 'Documento devolucion';
      }
    }

  }

  obtenerTipos(tipoRubro: number) {
    switch (tipoRubro) {
      case (0):
        return 'Conceptos financieros';
      case (1):
        return 'Combustible';
      case (2):
        return 'Lubricante';
      case (3):
        return 'Mercaderia';
      case (4):
        return 'Cigarrillos';
      case (5):
        return 'No Gravado';
    }

  }

  CompletarPrefijo(prefijo: number) {
    let p = prefijo.toString()
    return p.padStart(5, '0')
  }
  CompletarNumero(numero: number) {
    let n = numero.toString()
    return n.padStart(8, '0')
  }

  imputacionFacturaRemito() {
    //Vuelve a la parte superior al comprobante.
    let ele = document.getElementById('invoicingPrint');
    ele.scrollTop = 0;
    ele.scrollLeft = 0;
    this.importarFacturaremitos(this.facturaObtenida.prefijo, this.facturaObtenida.numeroComprobante, this.facturaObtenida.tipoMovimiento);
  }

  importarFacturaremitos(prefijo: number, numero: number, tipoMovimiento: number) {
    this.spinner.show('spinnerExportar');
    const url = `${this.exportarUrl}?prefijo=${prefijo.toString()}&numero=${numero.toString()}&tipoMovimiento=${tipoMovimiento.toString()}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    // Process the file downloaded
    this.httpClient.get(url, { headers: headers, responseType: 'blob' as 'json' })
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
        saveAs(blob, "factura" + prefijo + "-" + numero + ".xlsx");
        this.spinner.hide('spinnerExportar');
      });

  }

  clienteDiscriminaImpuestos() {
    if (this.facturaObtenida.cliente.condicionIvaDiscrimina) {
      return true;
    } else {
      return false;
    }
  }

  obtenerMoneda(moneda: number) {
    return TipoMoneda[moneda];
  }

  clienteExento() {
    if (this.facturaObtenida != null && this.facturaObtenida.cliente.condicionIvaCodigoAfip == '02') {
      return true
    } else {
      return false
    }
  }

  obtenerPorcentaje(leyenda: string): number {
    for (let reng of this.facturaObtenida.factura.renglones) {
      for (let imp of reng.impuestosPercepciones) {
        if (imp.leyenda == leyenda) {
          return imp.valor;
        }
      }
    }
  }

  verImpuestos() {
    let renglones: Renglon[] = [];
    let impuestos: ImpuestoPercepcion[] = [];
    
    this.facturaObtenida.factura.renglones.forEach((value, index) => {
      renglones.push(this.facturaObtenida.factura.renglones[index]);
      this.facturaObtenida.factura.renglones[index].impuestosPercepciones.forEach((value2, index2) => {
        impuestos.push(this.facturaObtenida.factura.renglones[index].impuestosPercepciones[index2]);
      });
    });
    let modalRef = this.activeModal.open(VisorImpuestoComponent, { size: 'lg', centered: true, backdrop: 'static' })
    modalRef.componentInstance.renglones = renglones;
  }

  incluirPorcentajeImpuesto(leyenda: string) {
    if(leyenda.includes('ITC') || leyenda.includes('IDC')){
      return false;
    }else{
      return true;
    }
  }


  descargar() {
    this.descargando = true;
    this.comprobanteService.descargarFactura(this.facturaObtenida)
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/pdf' });
        saveAs(blob, this.facturaObtenida.prefijo + '-' + this.facturaObtenida.numeroComprobante + ' ' + this.facturaObtenida.fechaHoraCreacion + '.pdf');
        this.descargando = false;
      }, () => {
        console.log("No se encontraron productos para exportar");
        this.descargando = false;
      });
  }

  reenviarCorreo(){
    this.mensajeError = null;
    this.reenviando = true;
    let comprobanteNotificaciones = new NotificacionesComprobantes();
    comprobanteNotificaciones.facturaId = this.facturaObtenida.id;
    comprobanteNotificaciones.numeroDocumento = this.facturaObtenida.cliente.numeroDocumento;
    comprobanteNotificaciones.codigoAeroplanta = this.facturaObtenida.codigoAeroplanta;
    comprobanteNotificaciones.tipoMovimiento = this.facturaObtenida.tipoMovimiento;
    comprobanteNotificaciones.prefijo = this.facturaObtenida.prefijo;
    comprobanteNotificaciones.numero = this.facturaObtenida.numeroComprobante;
    this.notificacionesService.enviarFactura(comprobanteNotificaciones)
      .subscribe((result) => {
        this.email = result;
        this.messageService.showSuccessLongMessage('El comprobante se reenvío a los correos: ' + this.email.item1);
        this.reenviando = false;
      }, (err: ErrorModel) => {
        this.messageService.showErrorLongMessage(err.description);
        this.reenviando = false;
      });
  }

  get esElectrica() {
    return environment.electrica
  }
}

